// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true, es9: true*/
const _ = require('lodash4');
const date = require('../../../../util/date.js');
const {fmt_currency} = require('../../../../util/conv.js');
const shared_constants = require('./constants.js');

const {BILLING_TYPES, APP_STATUSES, PLATFORMS, SELF_CHECK_FLOW, BUNDLE_SUFFIX,
    PERMISSION, SELF_CHECK_STAGE_META, PARTNER_TIER_META, PARTNER_TIER,
    PERMISSION_LVL, PERMISSION_META, PLATFORM_ALIASES,
    COMPLIANCE_SUFFIX} = shared_constants;
const MAX_DIGITS = 2;

const E = module.exports;

const is_app_disabled = a=>
    a.statuses?.[a.statuses?.length-1].status==APP_STATUSES.DISABLED;

E.is_app_disabled = is_app_disabled;

E.get_perms = rec=>rec.permissions || rec.sdk_permissions || {};

E.has_perm = (user, perm, req_lvl=PERMISSION_LVL.R)=>{
    if (!user)
        return false;
    if (user.is_root&&user.is_super_root)
        return true;
    const meta = PERMISSION_META[perm];
    if (user.is_root && !meta.root_permission)
        return true;
    const perms = E.get_perms(user);
    const target_perm = perms[perm]||0;
    const admin_perm = meta.root_permission
        ? 0
        : perms[PERMISSION.ORG_ADMIN]||0;
    const perm_lvl = Math.max(admin_perm, target_perm);
    return perm_lvl>=req_lvl;
};

E.stringify_url_state = (state={})=>{
    const params = {...state};
    if (!Object.keys(params).length)
        return null;
    return `state=${encodeURIComponent(JSON.stringify(params))}`;
};

E.is_tier_perk_available = (perk, partner_tier)=>{
    if (!partner_tier)
        return false;
    const required_tier = perk.min_tier || PARTNER_TIER.AUTHORIZED;
    const m = PARTNER_TIER_META;
    return m[partner_tier].power >= m[required_tier].power;
};

E.find_last_app_approval = statuses=>{
    let status = null;
    for (const st of statuses)
    {
        if (st.status==APP_STATUSES.APPROVED)
            status = st;
    }
    return status;
};

E.os2readable = os=>{
    const fixed_os = E.correct_os(os);
    return PLATFORMS[fixed_os]?.label || PLATFORM_ALIASES[fixed_os]?.label
        || fixed_os;
};

E.round_money = (amount, dec=2)=>{
    if (!amount||isNaN(amount))
        return 0;
    return parseFloat(Number(amount).toFixed(dec));
};

E.fmt$ = (amount, sign='$', digits=MAX_DIGITS, drop_decimals=false)=>{
    if (amount==='undefined' || amount===null || isNaN(amount) || amount==='')
        return '';
    const res = fmt_currency(amount, drop_decimals ? 0 : digits, sign);
    if (!res)
        return '';
    if (drop_decimals)
        return res;
    return res.includes('.') ? res : `${res}.00`;
};

E.get_yesterday = ()=>
    date.align(date.add(date(), {day: -1}), 'DAY');

E.get_billing_for_date = (data, ts=date())=>{
    if (!data)
        return null;
    const billing = data.billing ? data.billing : data;
    const b_list = Array.isArray(billing) ? billing : [billing];
    if (!b_list?.length)
        return null;
    let latest = null;
    let latest_date = date('2000-01-01');
    const now = date(ts);
    for (const b of b_list)
    {
        const b_from = date(b.start);
        if (b_from>=latest_date&&b_from<=now)
        {
            latest = b;
            latest_date = b_from;
        }
    }
    if (latest?.is_default)
        return null;
    if (latest?.type==BILLING_TYPES.EMPTY)
        return null;
    return latest;
};

E.get_billable_metric_by_billing = rec=>{
    if (!rec)
        return 'devices_qualified';
    if (rec.type==BILLING_TYPES.PER_OPTIN)
        return 'optins';
    if (rec.type==BILLING_TYPES.PER_INSTALL)
        return 'installs';
    return rec.type == BILLING_TYPES.PER_IP ? 'ips' : 'devices_qualified';
};

E.get_billable_metric = (entity, ts=date(), opts={})=>{
    const billing_rec = E.get_billing_for_date(entity, ts);
    if (!billing_rec && opts.return_if_empty)
        return null;
    return E.get_billable_metric_by_billing(billing_rec);
};

E.get_billable_metrics_list = (entity, ts=date())=>{
    const get_bm = E.get_billable_metric_by_billing;
    const get_b = E.get_billing_for_date;
    const res = [];
    const acitve_base_b = get_b(entity, ts);
    if (acitve_base_b)
        res.push(get_bm(acitve_base_b));
    for (const os of Object.keys(entity?.billing_per_os || {}))
    {
        const blist = entity.billing_per_os[os];
        const active_b = get_b(blist, ts);
        if (!active_b)
            continue;
        res.push(get_bm(active_b));
    }
    if (!res.length)
        res.push('devices_qualified');
    return _.uniq(res.filter(Boolean));
};

E.get_future_billings = (data=[], ts=date())=>{
    const res = [];
    if (!data)
        return [];
    const now = date(ts);
    for (const b of data)
    {
        const b_from = date(b.start);
        if (b_from>now)
            res.push(b);
    }
    res.sort((a, b)=>date(a.start)-date(b.start));
    return res;
};

E.get_scheduled_billing_cleanup = (data=[], ts=date())=>{
    const res = [];
    if (!data)
        return [];
    const now = date(ts);
    for (const b of data)
    {
        if (b.type!=BILLING_TYPES.EMPTY)
            continue;
        const b_from = date(b.start);
        if (b_from>now)
            res.push(b);
    }
    res.sort((a, b)=>date(a.start)-date(b.start));
    return res;
};

E.avg_gb_price = (_d, avg_gb_prices)=>{
    const d = date(_d);
    const {price=0} = _.find(avg_gb_prices, p=>date(p.start)<=d
        && (!p.end || date(p.end)>=d))||{};
    return price;
};

E.this_mo_or_later = ts=>{
    const mo_start = date.align(date(), 'month');
    return date(ts)>=mo_start;
};

E.correct_os = os=>{
    // some old apps has "windows" os value, but we use "win" for all new ones
    if (os=='windows')
        return 'win';
    // for legacy reasons in sdk_app collection we specify webos apps as node
    // but should treat it as webos throughout the code
    if (os=='node')
        return 'webos';
    return os;
};

E.os2selector = os=>{
    const correct_os = E.correct_os(os);
    const selector = {$in: []};
    if (correct_os=='win')
        selector.$in.push('windows');
    if (correct_os=='webos')
        selector.$in.push('node');
    else
        selector.$in.push(correct_os);
    return selector;
};

// checklists
E.get_section_key = sec_index=>`s_${sec_index}`;
E.get_question_key = q_index=>`q_${q_index}`;

E.get_self_check_flow = os=>{
    const ok_os = E.correct_os(os);
    return SELF_CHECK_FLOW.filter(step=>{
        const os_list = SELF_CHECK_STAGE_META[step]?.os||[];
        return os_list.length ? os_list.some(o=>o==ok_os) : true;
    });
};

E.find_last = (list, predicate)=>{
    for (let i=list.length-1; i>=0; i--)
    {
        if (predicate(list[i], i))
            return list[i];
    }
    return null;
};

E.get_salesforce_url = sf_id=>
    `https://brightdata.lightning.force.com/lightning/r/Account/${sf_id}/view`;

E.serialize_key = key=>key.replace(/\./g, '::');
E.deserialize_key = key=>key.replace(/::/g, '.');

E.get_app_checklist_id = app=>{
    if (!app)
        return null;
    let id = app.os;
    if (app.is_bundle)
        id += BUNDLE_SUFFIX;
    return id;
};

E.get_review_checklist_id = app=>{
    if (!app)
        return null;
    return app.os+COMPLIANCE_SUFFIX;
};

E.apply_billing_tier = (billing, tier_index)=>{
    const tier = billing.tiers[tier_index];
    const patch = tier?.then||{};
    const res = Object.assign({}, billing, patch);
    if (tier_index!=-1 && !patch.countries)
        delete res.countries;
    delete res.tiers;
    return res;
};
